import type { I18nLocale } from "@/modules/i18n/types"
import type { FunctionComponent } from "react"

import { clsx } from "clsx"

import { FLAG_ASSET } from "@/modules/headerFooterFO/flags/assets"
import { Link } from "@/modules/routing/components/Link"

import { AppLocalesDropdownItemLink } from "./AppLocalesDropdownItemLink"

import styles from "./LocalesDropdown.module.css"

type AppLocalesDropdownItemProps = {
  currentLocale: I18nLocale
  locale: I18nLocale
  href?: string
  translation?: string
}

export const AppLocalesDropdownItem: FunctionComponent<AppLocalesDropdownItemProps> = ({
  currentLocale,
  href,
  locale,
  translation,
}) => {
  const isLocaleSelected = locale === currentLocale
  const content = (
    <figure className={styles["hdr-DropdownMenu-submenuLinkItem"]}>
      <img src={FLAG_ASSET[locale as I18nLocale]} width="18" height="18" style={{ display: "block" }} alt="" />
      <figcaption className={styles["hdr-DropdownMenu-submenuLinkText"]}>{translation}</figcaption>
    </figure>
  )

  return (
    <li
      data-dropdown-locale={locale}
      className={clsx(styles["hdr-DropdownMenu-submenuItem"], {
        [styles["hdr-DropdownMenu-submenuItem--selected"]]: isLocaleSelected,
      })}
      key={locale}
    >
      {href ? (
        <Link href={href}>{content}</Link>
      ) : (
        <AppLocalesDropdownItemLink
          {...(isLocaleSelected ? { "aria-current": "page" } : {})}
          locale={locale}
          className={styles["hdr-DropdownMenu-submenuLink"]}
        >
          {content}
        </AppLocalesDropdownItemLink>
      )}
    </li>
  )
}
